import { useEffect } from "react";
import { BUSINESS_NAME } from "@/data/site";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} | Just Call Paul` : "Pressure Washing & Handyman in Citrus & Hernando County, FL | Just Call Paul";
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}

export { BUSINESS_NAME };
